import { Navigate } from "react-router-dom";
import { permissionService } from "./permissionService";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ resource, children }: any) {

  const { loading } = useAuth();

  if (loading) return null;

  const allowed = permissionService.checkAccess(resource);

  if (!allowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
}